// src/components/Palyazatok.jsx

import {
    Box,
    Button,
    Container,
    Heading,
    Image,
    SimpleGrid,
    Stack,
    Text,
    useBreakpointValue,
} from "@chakra-ui/react";
import { Link as ReactLink } from "react-router-dom";
import { palyazatok } from "../data/palyazatokData";

const Palyazatok = () => {
    const headingSize = useBreakpointValue({ base: "xl", md: "3xl" });
    const cardImageHeight = useBreakpointValue({ base: "180px", md: "220px" });

    return (
        <Box py={{ base: 10, md: 16 }} bg="gray.50">
            <Container maxW="8xl">
                <Stack spacing={3} textAlign="center" mb={{ base: 8, md: 12 }}>
                    <Heading
                        fontSize={headingSize}
                        fontFamily="'Playfair Display', serif"
                        color="gray.800"
                    >
                        PÁLYÁZATOK
                    </Heading>
                    {/* <Text
            maxW="3xl"
            mx="auto"
            color="gray.600"
            fontSize={{ base: "sm", md: "md" }}
          >
            Társaságunk fejlesztései és beruházásai támogatási programok
            segítségével valósulnak meg. Az alábbi projektek részletei itt
            érhetők el.
          </Text> */}
                </Stack>

                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8}>
                    {palyazatok.map((item) => (
                        <Box
                            display='flex'
                            flexDirection='column'
                            justifyContent='center'
                            alignItems='center'
                            key={item.id}
                            bg="white"
                            borderRadius="2xl"
                            overflow="hidden"
                            boxShadow="lg"
                            transition="all 0.25s ease"
                            _hover={{
                                transform: "translateY(-1px)",
                                boxShadow: "2xl",
                            }}
                        >
                            <Image
                                src={item.image}
                                alt={item.title}
                                w="80%"
                                h={cardImageHeight}
                                objectFit='contain'
                            />

                            <Stack spacing={4} p={{ base: 5, md: 7 }}>
                                <Text
                                    color="red.500"
                                    fontSize="sm"
                                    fontWeight="semibold"
                                    textTransform="uppercase"
                                >
                                    Pályázati projekt
                                </Text>

                                <Heading
                                    fontSize={{ base: "lg", md: "xl" }}
                                    color="gray.800"
                                    lineHeight="1.3"
                                >
                                    {item.title}
                                </Heading>

                                <Text color="gray.600" fontSize={{ base: "sm", md: "md" }}>
                                    {item.shortDescription}
                                </Text>

                                <Button
                                    as={ReactLink}
                                    to={`/palyazat/${item.slug}`}
                                    alignSelf="flex-start"
                                    bg="red.500"
                                    color="white"
                                    _hover={{ bg: "red.600" }}
                                    borderRadius="full"
                                    px={6}
                                >
                                    Részletek
                                </Button>
                            </Stack>
                        </Box>
                    ))}
                </SimpleGrid>
            </Container>
        </Box>
    );
};

export default Palyazatok;